import {Grid, Box} from "@material-ui/core";
import {Alert} from "@material-ui/lab";
import ProductItem from "./item";
import theme from "../theme";
import ProductThumbnail from "./thumbnail";
import {useTranslation} from "tools/i18n";
import React, { useEffect, useState } from 'react';
import {makeStyles} from "@material-ui/styles";
import {
	hasVariants,
	getProductUrl,
	getProductPrices,
	getIsAvailable,
	getCategoryBreadcrumb,
} from 'functions/productOps';
import useSessionStore from '@services/stores/SessionStore';

const useStyles = makeStyles(() => ({
	productGrid: {
		display: 'flex',
		flexWrap: 'wrap',
		gridTemplateColumns: "repeat(2, minmax(0, 50%))",
		gridAutoFlow: 'dense',
		gap: 4,
		[theme.breakpoints.up('sm')]: {
			gridTemplateColumns: "repeat(3, minmax(0, 33.333%))",
			gap: '20px 5px'
		},
		[theme.breakpoints.up('md')]: {
			gridTemplateColumns: "repeat(4, minmax(0, 25%))",
			gap: '20px 5px'
		}
	},
	productItem: {
		maxWidth: 'none'
	},
	plpInlineBanner: {
		display: 'inline-grid',
		gridColumn: '2 span',
		'& a': {
			display: 'block'
		},
		'& a img': {
			width: '100%',
			aspectRatio: '8.048 / 5', // compensating for the gutter/gap
			objectFit: 'cover',
		},
	}
}), {name: 'SWProductGrid'});

function SWProductGrid({products, productListing, list, breadcrumbs, paramsHash, lazyHydrate = true}) {
	const classes = useStyles();
	const config = useSessionStore((state) => state.session.config);
	const salesChannel = useSessionStore((state) => state.session.salesChannel);
	const {t} = useTranslation();
	const cf = salesChannel?.translated?.customFields;
	const [serverSide, setServerSide] = useState(true);
	const banner = {
		active: cf?.plp_inline_banner_active,
		src: cf?.plp_inline_banner_media,
		link: cf?.plp_inline_banner_link,
		alt: cf?.plp_inline_banner_alt || 'Newport',
		half: cf?.plp_inline_banner_width !== 'plp_inline_banner_width_full',
	}

	useEffect(() => {
		setServerSide(false);
	}, []);

	return (
		<Box component="div" className={[classes.productGrid, 'product-grid'].join(' ')} style={{display: 'grid'}} key={paramsHash + 'box-key'}>
			{products.length > 0 ? products.map((product, key) =>
				<React.Fragment key={product.productNumber + '-frag'}>
					<ProductItem
						id={product.id}
						productNumber={product.productNumber}
						name={product.translated.name}
						link={getProductUrl(product)}
						prices={getProductPrices(product)}
						image={<ProductThumbnail product={product} image={product.cover} alt={product.translated?.name} size={550} index={key} key={key}/>}
						list={list}
						categoryBreadcrumb={getCategoryBreadcrumb(breadcrumbs)}
						manufacturer={product.manufacturer ? product.manufacturer.translated.name : ''}
						variants={hasVariants(product)}
						stock={product.availableStock}
						deliveryTimeString={{id: product.deliveryTimeId}}
						available={getIsAvailable(product)}
						isOutlet={!!product?.translated?.customFields?.is_outlet_product}
						addToCart={'minimal'}
						like={true}
						lazyHydrate={lazyHydrate}
						fastDelivery={product?.translated?.customFields?.fast_delivery_available && config.language.locale === 'sv'}
						customClasses={{item: classes.productItem}}
						position={key + 1}
						key={paramsHash + product.productNumber + key}
						propertyIds={product.propertyIds}
						streamIds={product.streamIds}
						analytics={product?.extensions?.newport?.analytics}
					/>
					{!serverSide && key === 5 && productListing.page === 1 && banner.active ?
						<div key={'prd-Div-' + key} className={[classes.plpInlineBanner, banner.half ? 'half' : ''].join(' ')}>
							<a href={banner.link}>
								<img src={banner.src} alt={banner.alt} />
							</a>
						</div>
					: ''}
				</React.Fragment>
			) :
				<Grid key={paramsHash + 'empt-grd-key'} xs={12} item>
					<Alert severity="warning">{t('empty-category')}</Alert>
				</Grid>}
		</Box>
	);
}

export default SWProductGrid;
